export enum DebugNamespaces {
  USER = 'user',
  ADMIN = 'admin',
  ABLY = 'ably',
  SANITY = 'sanity',
  USER_APOLLO = 'user:apollo',
  ADMIN_APOLLO = 'admin:apollo',
}